<form [formGroup]="sendForm" class="u-mt32">
    <aix-header-section [title]="'Message'">
        <div class="order-step-action-items">
            <aix-button
                style="padding-top: 2px"
                class="order-step-action-items__menu-button"
                [data-testing]="'templateMenuOptions'"
                [isDisabled]="isAssignBoxOpen()"
                [buttonLabel]="'Template'"
                [buttonType]="templateButtonType"
                [icon]="'fa-ellipsis-v'"
            ></aix-button>
            <ul class="order-step-action-items-menu aix-flex-grid aix-flex-grid__col">
                <li>
                    <aix-button
                        [data-testing]="'editTemplate'"
                        [buttonLabel]="'Edit'"
                        (click)="editTemplate()"
                        [isDisabled]="isDefaultTemplate"
                        [buttonType]="templateButtonType"
                    >
                    </aix-button>
                </li>
                <li>
                    <aix-button
                        [data-testing]="'removeTemplate'"
                        [buttonLabel]="'Remove'"
                        (click)="removeTemplate()"
                        [isDisabled]="isDefaultTemplate"
                        [buttonType]="templateButtonType"
                    >
                    </aix-button>
                </li>
                <hr class="u-mt8" />
                <li>
                    <aix-button
                        [data-testing]="'createTemplate'"
                        [buttonLabel]="'Create New'"
                        (click)="createTemplate()"
                        [buttonType]="templateButtonType"
                    >
                    </aix-button>
                </li>
            </ul>
        </div>
    </aix-header-section>

    <div class="aix-form aix-form--centered">
        <div class="u-mt16">
            @if (!isAssignBoxOpen()) {
            <aix-notification
                #saveTemplateNotificationRef
                status="ok"
                [canClose]="true"
                [isOpen]="false"
                [classList]="['u-mb16']"
            >
                <strong>Success!</strong> Template Saved.
            </aix-notification>
            <aix-notification
                #removeTemplateNotificationRef
                status="ok"
                [canClose]="true"
                [isOpen]="false"
                [classList]="['u-mb16']"
            >
                <strong>Success!</strong> Template Deleted.
            </aix-notification>
            <div>
                <ng-content select="#from"></ng-content>
                <div class="aix-form__group">
                    <aix-dropdown
                        formControlName="emailTemplate"
                        [data-testing]="'emailTemplate'"
                        [isValid]="
                            sendForm?.value?.emailTemplate?.length >= 0
                                ? !!sendForm?.value?.emailTemplate?.length
                                : !!sendForm?.value?.emailTemplate
                        "
                        [aixDisabled]="isDefaultTemplate && templates.length === 1"
                        [isRequired]="true"
                        labelField="name"
                        valueField="id"
                        placeholder=""
                        [options]="templates"
                        (ngModelChange)="onTemplateChange($event)"
                    >
                        Template
                    </aix-dropdown>
                </div>
                <div class="aix-form__group">
                    <aix-input
                        formControlName="emailSubject"
                        [data-testing]="'emailSubject'"
                        [config]="{ refId: 'email-input' }"
                        [isValid]="!!sendForm.get('emailSubject')?.valid"
                        [isRequired]="true"
                    >
                        Subject
                    </aix-input>

                    @if (sendForm.value?.emailSubject && sendForm.get('emailSubject')?.invalid) {
                    <div class="form-error--container">
                        <div class="form-error">
                            Email subject line must be less than 100 characters.
                        </div>
                    </div>
                    }
                </div>

                <div class="aix-form__group u-mt-1">
                    @if (useRichText()) {
                    <aix-rich-text
                        formControlName="emailBody"
                        [data-testing]="'emailBody'"
                        [isRequired]="true"
                        [isDisabled]="false"
                        [isValid]="!!sendForm.get('emailBody')?.valid"
                        >Message
                    </aix-rich-text>
                    } @else {
                    <aix-textarea
                        formControlName="emailBody"
                        [data-testing]="'emailBody'"
                        [height]="192"
                        [isRequired]="true"
                        [isDisabled]="false"
                        [isValid]="!!sendForm.get('emailBody')?.valid"
                        >Message
                    </aix-textarea>
                    }
                </div>
            </div>
            @if (emailSettings()?.disclosureEnabled) {
            <div [data-testing]="'disclosure'">
                <p>This email will include a disclosure set by your firm.</p>
                @if (showDisclosure) {
                <blockquote
                    class="u-flex flex-col u-p24 u-mt16 u-mb16"
                    [data-testing]="'disclosure-message'"
                >
                    {{ emailSettings()?.disclosureMessage }}
                </blockquote>
                }
                <a
                    (click)="showDisclosure = !showDisclosure"
                    class="aix-btn aix-btn--link br-link"
                    [data-testing]="'disclosure-button'"
                >
                    @if (showDisclosure) { Show Less... } @else { Show More... }
                </a>
            </div>
            } } @if (isAssignBoxOpen()) {
            <div>
                <aix-assign-box-template
                    [editRecord]="selectedTemplate"
                    [checkboxDescription]="description()"
                    [useRichText]="useRichText()"
                    (onHide)="onHideAssignBoxTemplate()"
                    (onSave)="onSaveAssignBoxTemplate($event)"
                >
                </aix-assign-box-template>
            </div>
            } @if (!recipientError()) {
            <div class="u-mt24 aix-flex-grid__col aix-form__container">
                <aix-error-box
                    [canClose]="true"
                    [states]="states()"
                    [data-testing]="'error-notification'"
                ></aix-error-box>
            </div>
            } @if (recipientError()) {
            <div class="u-mt24 aix-flex-grid__col aix-form__container">
                <aix-notification
                    status="warning"
                    [canClose]="true"
                    [isOpen]="true"
                    [classList]="['u-mb8']"
                    [data-testing]="'undeliverable-email-notification'"
                >
                    <p>
                        The following email addresses are undeliverable. This may be due to an
                        incorrect or misspelled email address. To resolve the issue, please
                        <a class="br-link" (click)="onEditOrder()">edit order</a>.
                    </p>
                    <ul>
                        @for (email of recipients(); track email) {
                        <li class="u-ml24">
                            <a class="br-link">{{ email }}</a>
                        </li>
                        }
                    </ul>
                </aix-notification>
            </div>
            }

            <div class="aix-toolbar u-mt24">
                <ng-content select="#toolbar"></ng-content>
            </div>
        </div>
    </div>
</form>
<aix-modal
    #removeTemplateModal
    modalType="confirmation"
    [data-testing]="'remove-template-modal'"
    [modalTitle]="'Remove Template?'"
    (optionSelected)="confirmRemoveTemplate($event)"
>
    <ng-template>
        <p class="u-fw500">Template will be permanently removed.</p>
        <p>You can create a new template at any time.</p>
    </ng-template>
</aix-modal>
